import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  }
};

function ButtonsPocetna({ setIsDodavanje }) {
  const { dictionary } = useGlobalContext();

  const handleDodaj = () => {
    setIsDodavanje(true);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "15px"
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <div>
          <Button activation={true} style={styles.button}>
            {dictionary["stampaj"]}
          </Button>
        </div>
        <div>
          <Button activation={true} style={styles.button}>
            {dictionary["posalji"]}
          </Button>
        </div>
      </div>
      <div onClick={handleDodaj}>
        <Button activation={true} style={styles.button}>
          {dictionary["dodaj"]}
        </Button>
      </div>
    </div>
  );
}

export default ButtonsPocetna;
